<!-- 车辆信息上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carList": [
                    {
                        "addBy": "admin",
                        "addTime": "20170929160020",
                        "carColor": 0,
                        "carLicenseColor": 0,
                        "carLicenseNumber": "津M95621",
                        "carLicenseType": 0,
                        "carLogo": 0,
                        "carOwnType": 0,
                        "carSeq": 7,
                        "carSizeType": 0,
                        "carType": 0,
                        "customerSeq": 5,
                        "deleted": false,
                        "similarPlates": ""
                    }
                ],
                "cmd": "reportCar",
                "parkCode": "2KM9J7GC",
                "reportTime": "20170929160020"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场车辆信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportCar",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'reportTime', info2: '是', info3: 'String', info4: '上报时间，yyyyMMddHHmmss' },
                        { info1: 'carList', info2: '是', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'carList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'customerId', info2: '是', info3: 'String', info4: '车主ID，由外部平台生成的唯一编号' },
                        { info1: 'customerSeq', info2: '是', info3: 'int', info4: '车主在vems的递增序列号' },
                        { info1: 'carSeq', info2: '是', info3: 'int', info4: '车辆在vems的递增序列号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'carLicenseColor', info2: '是', info3: 'int', info4: '车牌颜色' },
                        { info1: 'carLicenseType', info2: '是', info3: 'int', info4: '车牌类型' },
                        { info1: 'carColor', info2: '是', info3: 'int', info4: '车辆颜色' },
                        { info1: 'carLogo', info2: '是', info3: 'int', info4: '车辆品牌' },
                        { info1: 'carModel', info2: '是', info3: 'String', info4: '品牌型号' },
                        { info1: 'carFullPicture', info2: '是', info3: 'String', info4: '车辆图片' },
                        { info1: 'carType', info2: '是', info3: 'int', info4: '车辆类型' },
                        { info1: 'carOwnType', info2: '是', info3: 'int', info4: '车归属类型，0未知，1公车，2私车' },
                        { info1: 'addTime', info2: '是', info3: 'String', info4: '添加时间，yyyyMMddHHmmss' },
                        { info1: 'addBy', info2: '是', info3: 'String', info4: '添加操作人' },
                        { info1: 'carSizeType', info2: '是', info3: 'int', info4: '车辆大小类型，0未知，1小车，2大车，3超大车，4中型车' },
                        { info1: 'similarPlates', info2: '是', info3: 'String', info4: '模糊匹配车牌号（逗号分隔）' },
                        { info1: 'isDeleted', info2: '是', info3: 'boolean', info4: '是否逻辑删除，false未删除，true删除' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportCar.vue